import { useEffect, useState } from 'react'
import { requestQueue } from '../utils/requestQueue'

export const useRequestQueue = () => {
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    const cb = (queue) => {
      // eslint-disable-next-line no-magic-numbers
      setIsLoading(queue.length > 0)
    }
    requestQueue.addEventListener(cb)
    return () => {
      requestQueue.removeEventListener(cb)
    }
  }, [isLoading])
  return isLoading
}
